import vantEnLocale from 'vant/es/locale/lang/en-US';
import vantZhLocale from 'vant/es/locale/lang/zh-CN';
import vantDeLocale from 'vant/es/locale/lang/de-DE';
import vantTrLocale from 'vant/es/locale/lang/tr-TR';
import vantRoLocale from 'vant/es/locale/lang/ro-RO';
import vantFrLocale from 'vant/es/locale/lang/fr-FR';
import vantEsLocale from 'vant/es/locale/lang/es-ES';

import enLocaleCfmoto from './lang/en';
import zhLocaleCfmoto from './lang/zh-CN';
import frLocaleCfmoto from './lang/fr';
import esLocaleCfmoto from './lang/es';
import deLocaleCfmoto from './lang/de';
import itLocaleCfmoto from './lang/it';
import ptLocaleCfmoto from './lang/pt';
import ruRULocaleCfmoto from './lang/ru-RU';
import csLocaleCfmoto from './lang/cs';
import plLocaleCfmoto from './lang/pl';
import roLocaleCfmoto from './lang/ro';
import srLocaleCfmoto from './lang/sr';
import svLocaleCfmoto from './lang/sv';
import trLocaleCfmoto from './lang/tr';

const languages = [
  'af',
  'sq',
  'ar-SA',
  'ar-IQ',
  'ar-EG',
  'ar-LY',
  'ar-DZ',
  'ar-MA',
  'ar-TN',
  'ar-OM',
  'ar-YE',
  'ar-SY',
  'ar-JO',
  'ar-LB',
  'ar-KW',
  'ar-AE',
  'ar-BH',
  'ar-QA',
  'eu',
  'bg',
  'be',
  'ca',
  'zh-TW',
  'zh-CN',
  'zh-HK',
  'zh-SG',
  'hr',
  'cs',
  'da',
  'nl',
  'nl-BE',
  'en',
  'en-US',
  'en-EG',
  'en-AU',
  'en-GB',
  'en-CA',
  'en-NZ',
  'en-IE',
  'en-ZA',
  'en-JM',
  'en-BZ',
  'en-TT',
  'et',
  'fo',
  'fa',
  'fi',
  'fr',
  'fr-BE',
  'fr-CA',
  'fr-CH',
  'fr-LU',
  'gd',
  'gd-IE',
  'de',
  'de-CH',
  'de-AT',
  'de-LU',
  'de-LI',
  'el',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'it',
  'it-CH',
  'ja',
  'ko',
  'lv',
  'lt',
  'mk',
  'mt',
  'no',
  'pl',
  'pt-BR',
  'pt',
  'rm',
  'ro',
  'ro-MO',
  'ru',
  'ru-MI',
  'ru-RU',
  'sz',
  'sr',
  'sk',
  'sl',
  'sb',
  'es',
  'es-AR',
  'es-GT',
  'es-CR',
  'es-PA',
  'es-DO',
  'es-MX',
  'es-VE',
  'es-CO',
  'es-PE',
  'es-EC',
  'es-CL',
  'es-UY',
  'es-PY',
  'es-BO',
  'es-SV',
  'es-HN',
  'es-NI',
  'es-PR',
  'sx',
  'sv',
  'sv-FI',
  'th',
  'ts',
  'tn',
  'tr',
  'uk',
  'ur',
  've',
  'vi',
  'xh',
  'ji',
  'zu',
];

export const messages = {
  // 汉语
  zh: { ...zhLocaleCfmoto, ...vantZhLocale },
  // 英语
  en: { ...enLocaleCfmoto, ...vantEnLocale },
  // 西班牙语
  es: { ...esLocaleCfmoto, ...vantEsLocale },
  // 法语
  fr: { ...frLocaleCfmoto, ...vantFrLocale },
  // 德语
  de: { ...deLocaleCfmoto, ...vantDeLocale },
  // 葡萄牙
  pt: { ...ptLocaleCfmoto, ...vantEnLocale },
  // 意大利
  it: { ...itLocaleCfmoto, ...vantEnLocale },
  // 俄罗斯
  ru: { ...ruRULocaleCfmoto, ...vantEnLocale },
  // 捷克语
  cs: { ...csLocaleCfmoto, ...vantEnLocale },
  // 波兰语
  pl: { ...plLocaleCfmoto, ...vantEnLocale },
  // 罗马尼亚语
  ro: { ...roLocaleCfmoto, ...vantRoLocale },
  // 塞尔维亚语
  sr: { ...srLocaleCfmoto, ...vantEnLocale },
  // 瑞典语
  sv: { ...svLocaleCfmoto, ...vantEnLocale },
  // 土耳其语
  tr: { ...trLocaleCfmoto, ...vantTrLocale },
};

// 默认英文
languages.forEach((key) => {
  const newKey = Object.keys(messages).filter((messageKey) => key.includes(messageKey))[0] || 'en';
  messages[key] = messages[newKey];
});

export default {};
